import { ReactNode } from 'react';
import Panel from '../Panel';
import Grid, { IGridProps } from '../Grid';
import NavigationList from './components/NavigationList';
import { ColorTypeEnum } from '../../enums';

export interface INavigationPanelProps extends IGridProps {
  children: ReactNode;
}

export { default as NavigationItem, type INavigationItemProps } from './components/NavigationItem';
export { default as NavigationSubHeader } from './components/NavigationSubHeader';

const NavigationPanel = (props: INavigationPanelProps) => {
  const { children, ...rest } = props;
  return (
    <Grid {...rest}>
      <Panel color={ColorTypeEnum.Secondary}>
        <NavigationList>
          {children}
        </NavigationList>
      </Panel>
    </Grid>
  );
};

export default NavigationPanel;
